const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

function toDate(iso) {
  if (typeof iso !== 'string') return null
  const trimmed = iso.trim()
  if (!trimmed) return null
  const date = new Date(trimmed)
  return Number.isNaN(date.getTime()) ? null : date
}

export function isBotDate(iso) {
  return toDate(iso) !== null
}

function clockLabel(date) {
  const minutes = String(date.getUTCMinutes()).padStart(2, '0')
  const meridiem = date.getUTCHours() >= 12 ? 'PM' : 'AM'
  let hour = date.getUTCHours() % 12
  if (hour === 0) hour = 12
  return `${hour}:${minutes} ${meridiem}`
}

export function formatBotDate(iso, now = Date.now()) {
  const date = toDate(iso)
  if (!date) return iso
  const weekday = WEEKDAYS[date.getUTCDay()]
  const day = date.getUTCDate()
  const month = MONTHS[date.getUTCMonth()]
  const year = date.getUTCFullYear()
  const base = `${weekday}, ${day} ${month}`
  const currentYear = new Date(now).getUTCFullYear()
  return year === currentYear ? base : `${base} ${year}`
}

export function formatBotTime(iso) {
  const date = toDate(iso)
  if (!date) return iso
  return clockLabel(date)
}

export function formatBotDateTime(iso) {
  const date = toDate(iso)
  if (!date) return iso
  const day = date.getUTCDate()
  const month = MONTHS[date.getUTCMonth()]
  return `${day} ${month}, ${clockLabel(date)}`
}
